<template>
	<div class="steinComponent container mt-5">

		<div class="title">
			<h1>{{this.game.name}}</h1>
			<div class="description">{{this.game.description}}</div>
		</div>

		<b-dropdown text="Spiel auswählen" class="selectGame">
			<b-dropdown-item
					v-for="(game, i) in games"
					:key="game.name"
					@click="() => selectGame(i)"
			>{{game.name}}
			</b-dropdown-item>
		</b-dropdown>

		<div class="boxes">
			<PlayerBox
					:name="nameP1"
					@nameChange="name => this.nameP1 = name"
					:keyMap="keyMaps[0]"
					:icon="(roundFinished || itemP1.id !== 'default') ? itemP1.icon : null"
					:win="(roundFinished && !acceptingInputs && result !== 0) ? result === 1 : null"
					:score="scoreP1"
			/>

			<div class="countdownContainer" :key="countdownStartTimestamp">
				<div v-if="!showCountdown">vs</div>
				<Countdown
						v-if="showCountdown"
						:seconds="timerSeconds"
						@gracePeriodStart="graceStart"
						@gracePeriodEnd="graceEnd"
						@countdownEnd="roundEnd"
				/>
			</div>

			<PlayerBox
					:name="nameP2"
					@nameChange="name => this.nameP2 = name"
					:keyMap="keyMaps[1]"
					:icon="(roundFinished || itemP2.id !== 'default') ? itemP2.icon : null"
					:win="(roundFinished && !acceptingInputs && result !== 0) ? result === 2 : null"
					:score="scoreP2"
			/>
		</div>

		<div class="button">
			<button class="btn btn-lg btn-danger" v-if="isRunning" @click="stop">Stop</button>
			<button class="btn btn-lg btn-success" v-else @click="start">Start</button>
		</div>
	</div>
</template>

<script>
  import Countdown from "./Countdown";
  import {defaultItem, games} from "../games";
  import PlayerBox from "./PlayerBox";

  const freshGameState = {
    showCountdown: false,
    acceptingInputs: false,
    roundFinished: false,
    itemP1: defaultItem,
    itemP2: defaultItem,
  };


  export default {
    components: {PlayerBox, Countdown},

    created() {
      document.addEventListener("keydown", this.checkKeyPress);
    },
    beforeDestroy() {
      document.removeEventListener("keydown", this.checkKeyPress);
    },

    data: function () {
      return {
        activeGameIndex: 0,
        nameP1: 'Spieler 1',
        nameP2: 'Spieler 2',
        scoreP1: 0,
        scoreP2: 0,
        isRunning: false,
        countdownStartTimestamp: Date.now(),
        ...freshGameState,
      }
    },

    computed: {
      game() {
        return this.games[this.activeGameIndex];
      },
      games() {
        return games;
      },
      timerSeconds() {
        return 3;
      },
      waitBetweenRounds() {
        return 1500;
      },
      keyMaps() {
        const keyMapP1 = {};
        const keyMapP2 = {};
        for (let item of Object.values(this.game.items)) {
          keyMapP1[item.keyP1] = item;
          keyMapP2[item.keyP2] = item;
        }
        return [keyMapP1, keyMapP2];
      },
      result() {
        // Nobody chose an item, or both chose the same item
        if (this.itemP1.id === this.itemP2.id) return 0;
        // P1 didn't choose an item
        else if (this.itemP1.id === 'default') return 2;
        // P2 didn't choose an item
        else if (this.itemP2.id === 'default') return 1;
        // P1 and P2 chose different items
        else return this.game.winMatrix[this.itemP1.id].includes(this.itemP2.id) ? 1 : 2;
      },
    },

    methods: {
      selectGame(index) {
        this.stop();
        this.activeGameIndex = index;
      },
      checkKeyPress(event) {
        if (!this.acceptingInputs) return;
        const itemP1 = this.keyMaps[0][event.key];
        const itemP2 = this.keyMaps[1][event.key];
        if (itemP1) this.itemP1 = itemP1;
        if (itemP2) this.itemP2 = itemP2;
      },
      resetGameState() {
        for (let [key, value] of Object.entries(freshGameState)) {
          this[key] = value;
          this.countdownStartTimestamp = Date.now();
        }
      },
      increaseWinnerScore() {
        if (this.result === 1) ++this.scoreP1;
        else if (this.result === 2) ++this.scoreP2;
      },
      roundStart() {
        this.resetGameState();
        this.showCountdown = true;
        this.roundFinished = false;
      },
      roundEnd() {
        this.roundFinished = true;
        this.restartTimer = setTimeout(() => {
          this.roundStart();
        }, this.waitBetweenRounds);
      },
      graceStart() {
        this.acceptingInputs = true;
      },
      graceEnd() {
        this.acceptingInputs = false;
        this.increaseWinnerScore();
      },
      start() {
        this.isRunning = true;
        this.roundStart();
      },
      stop() {
        clearTimeout(this.restartTimer);
        this.isRunning = false;
        this.resetGameState();
      },
    },
  };

</script>


<style scoped>
	.title {
		text-align: center;
		margin-bottom: 40px;
	}

	.title h1 {
		font-variant: small-caps;
		margin-bottom: 0;
	}

	.title .description {
		color: #888;
	}

	.selectGame {
		position: fixed;
		top: 0;
		right: 0;
	}

	.boxes {
		display: flex;
		justify-content: center;
	}

	.countdownContainer {
		width: 300px;
		height: 400px;
		font-size: 200px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.button {
		text-align: center;
	}

	.button > button {
		height: 100px;
		width: 100px;
		border-radius: 50px;
		font-size: 30px;
	}
</style>

<style>
	.steinComponent .selectGame button {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-top-left-radius: 0;
	}
</style>


